import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaExclamationTriangle } from "react-icons/fa";
import "../../styles/rh-modern-ui.css";

const MySwal = withReactContent(Swal);

const ConfirmDeleteModal = ({ show, handleClose, employe, token, refreshData }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    if (!employe?.id_employe) {
      MySwal.fire("Erreur", "Aucun employé sélectionné", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.delete(`/employes/${employe.id_employe}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      MySwal.fire("✅ Employé Supprimé", res.data?.message || "", "success");
      refreshData();
      handleClose();
    } catch (err) {
      const msg = err.response?.data?.detail?.message || err.response?.data?.detail || "Erreur de suppression";
      MySwal.fire("Erreur ❌", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" className="rh-modern-modal">
      <Modal.Header closeButton className="rh-modal-header rh-modal-header-danger">
        <div>
          <Modal.Title><FaExclamationTriangle className="me-2" />Confirmation</Modal.Title>
          <div className="rh-modal-subtitle">Cette action est irréversible.</div>
        </div>
      </Modal.Header>
      <Modal.Body className="rh-modal-body">
        <div className="rh-delete-warning">
          Êtes-vous sûr de vouloir supprimer l&apos;employé{" "}
          <strong>{employe?.prenom} {employe?.nom}</strong> ?
        </div>
      </Modal.Body>
      <Modal.Footer className="rh-modal-footer">
        <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleConfirmDelete} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Supprimer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
